// extracted by mini-css-extract-plugin
export default {"card":"u5-z"};